import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RouteConfigurationWithSchema } from '../../shared/models/route';
import { firstValueFrom } from 'rxjs';
import { LineLayerSpecification } from 'maplibre-gl';
import { JsonApiResponse } from '../../shared/models/JsonApiResponse';
import { catchError, map } from 'rxjs/operators';
import { HttpErrorHandler } from '../../http.error.handler';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LambdaService {

  constructor(
    private http: HttpClient,
  ) {
  }

  routeConfigToLineLayerSpecifications(routeConfiguration: RouteConfigurationWithSchema) {
    return firstValueFrom(
      this.http
        .post<JsonApiResponse<LineLayerSpecification[]>>(
          `${environment.services.lambda}route-config-to-line-layers/translate`,
          routeConfiguration,
        )
        .pipe(
          catchError(HttpErrorHandler.handleError),
          map(response => response.data)
        )
    );
  }
}
